/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';
/*
 * TODO: This needs to be a real URL via a bundle, not a blob url.
 * BUG: The functions that are stringified into the blob MUST NOT contain references to
 *      entities that will be compiled.
 *      E.g. References to enums may be different when compiled and/or minified.
 */

import BENDER_ES_LINT_URL from 'bender-url!browser-eslint/eslint.js';
import { version as browserESLintVersion } from 'browser-eslint';
import AnnotationType from 'react-codemirror/enum/AnnotationType';
const ES_LINT_URL = `https:${BENDER_ES_LINT_URL}`;
/**
 * IE11 does not support `Object.assign()`
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill}
 */

const OBJECT_ASSIGN_POLYFILL = `
  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }
`;

function parseRangeValues(error) {
  if (!error) {
    return {};
  }

  return {
    line: error.line == null ? null : error.line - 1,
    endLine: error.endLine == null ? null : error.endLine - 1,
    column: error.column == null ? null : error.column - 1,
    endColumn: error.endColumn == null ? null : error.endColumn - 1
  };
}
/**
 * Gets the snippet of code eslint has identified in the error.
 *
 * @param {Object}          error An individual error message object as returned by eslint.verify().
 * @param {Array.<String>}  lines Array of source code lines as parsed by eslint.
 */


function getEvidence(error, lines, parseRange) {
  const noEvidence = '';

  if (!error) {
    return noEvidence;
  }

  if (!(lines && lines.length)) {
    return noEvidence;
  }

  const range = parseRange(error);
  const line = range.line;
  const endLine = range.endLine;
  const column = range.column;
  const endColumn = range.endColumn;

  if (!(line != null && endLine != null && column != null && endColumn != null && lines.length > line && lines.length > endLine)) {
    return noEvidence;
  }

  if (endLine === line) {
    return lines[line].slice(column, endColumn);
  }

  if (endLine > line) {
    const result = new Array(endLine - line);

    for (let index = 0, currLine = line; currLine <= endLine; ++index, ++currLine) {
      const code = lines[currLine];

      if (currLine === line) {
        result[index] = code.slice(column);
      } else if (currLine === endLine) {
        result[index] = code.slice(0, endColumn);
      } else {
        result[index] = code;
      }
    }

    return result.join('\n');
  }

  return noEvidence;
}
/**
 * Get ESLint recommended rules
 *
 * @param {ESLint} linter
 */


function getRecommendedRules(linter) {
  // https://eslint.org/docs/rules/}
  const RULE_IDS = {
    OFF: 'off',
    // 0
    WARN: 'warn',
    // 1
    ERROR: 'error' // 2

  };
  const CATEGORY_TO_RULE_ID = {
    'ECMAScript 6': RULE_IDS.ERROR,
    'Best Practices': RULE_IDS.ERROR,
    'Possible Errors': RULE_IDS.ERROR,
    Variables: RULE_IDS.ERROR,
    'Stylistic Issues': RULE_IDS.WARN
  };
  const rulesMap = linter.getRules();
  const rules = {}; // eslint-disable-next-line

  rulesMap.forEach(function (value, ruleName) {
    const docs = value.meta.docs;

    if (docs.recommended) {
      rules[ruleName] = CATEGORY_TO_RULE_ID[docs.category] || RULE_IDS.ERROR;
    }
  });
  return Object.freeze(rules);
}
/**
 * Get config from options passed.
 *
 * @param {Object} options
 * @param {Object} recommendedRules
 */


function getConfigFromOptions(options, recommendedRules) {
  const config = options.config ? Object.assign({}, options.config) : {};

  if (options.extendESLintRecommended === true || config.extends && config.extends === 'eslint:recommended' || Array.isArray(config.extends) && ~config.extends.indexOf('eslint:recommended')) {
    config.rules = Object.assign({}, recommendedRules, config.rules || {});
  }

  return config;
}

const WORKER_BLOB = new Blob([`
  importScripts('${ES_LINT_URL}');

  ${OBJECT_ASSIGN_POLYFILL}

  const AnnotationType = ${JSON.stringify(AnnotationType, null, 2)};

  const parseRangeValues = ${parseRangeValues.toString()};
  const getEvidence = ${getEvidence.toString()};
  const getConfigFromOptions = ${getConfigFromOptions.toString()};

  const linter = ${browserESLintVersion === '2' ? 'new eslint.Linter();' : 'new eslint();'}

  const recommendedRules = ${getRecommendedRules.toString()}(linter);
  self.addEventListener('message', function(event) {
    const value = event.data.value;
    const options = event.data.options || {};
    const id = event.data.id;
    const annotations = [];
    const config = getConfigFromOptions(options, recommendedRules);

    const result = linter.verify(value, config, options.options);

    const sourceCode = linter.getSourceCode();
    // If there is a "Parsing error" sourceCode will be null.
    const lines = sourceCode
      ? sourceCode.getLines()
      : null;

    result.forEach(function(msg) {
      const range = parseRangeValues(msg);
      const anno = {
        type: msg.severity === 2 ? AnnotationType.ERROR : AnnotationType.WARNING,
        lineNumber: range.line,
        endLineNumber: range.endLine,
        column: range.column,
        endColumn: range.endColumn,
        message: msg.message,
        evidence: getEvidence(msg, lines, parseRangeValues),
      };
      annotations.push(anno);
    });

    self.postMessage(JSON.stringify({
      id: id,
      result: result,
      annotations: annotations,
    }));
  });
`], {
  type: 'text/javascript'
});
/**
 * Web Worker URL for ESLint.
 *
 * @type {String}
 * @example
 * const worker = new Worker(WORKER_URL);
 * worker.postMessage({ id, value, options });
 */

export const WORKER_URL = URL.createObjectURL(WORKER_BLOB);